import React from "react";
import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import Labels from "../../Labels";
import { FormStepsProps } from "../FormStepsProps";

const TagsFormSection = ({
  tagsToRender,
  setValue,
  getValues,
}: FormStepsProps) => {
  const { t } = useTranslation();
  return (
    <div className="TagsFormSection-container">
      <section className="extra-lower-padding">
        <SubTitle underLine>{t("labeling")}</SubTitle>
        <Labels
          tags={tagsToRender}
          isButton
          setValue={setValue}
          getValues={getValues}
        />
      </section>
    </div>
  );
};
export default TagsFormSection;
